import { Button, ChevronLeftIcon } from '@sailadv/hdata-ui';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AppRoutes } from '@/shared/constants/app-routes.constant';

const PageBackButtonComponent = () => {
	const { t } = useTranslation('common');
	const navigate = useNavigate();

	const handleBack = () => {
		// react-router keeps the history index in state, 0 means the page was opened directly
		const hasHistory = (window.history.state?.idx ?? 0) > 0;

		if (hasHistory) {
			navigate(-1);
			return;
		}

		navigate(AppRoutes.Home);
	};

	return (
		<Button variant="ghost" size="xs" leadingIcon={<ChevronLeftIcon />} onClick={handleBack}>
			{t('page.back')}
		</Button>
	);
};

export default memo(PageBackButtonComponent);
